<template>
	<compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
		<compFormEdit
			ref="accountform"
			class="margin-layout"
			:formdata="getBase"
			v-model="formData"
		></compFormEdit>
		<vButtonGroup class="text-right margin-top-15 margin-right-15">
			<vButton theme="primary" @click="submit">确定</vButton>
			<vButton @click="close">取消</vButton>
		</vButtonGroup>
		<vLoading size="large" fix :loading="loading"></vLoading>
	</compWrapper>
</template>
<script>
import { HttpFuelExtraOne, HttpSaveFuelExtra, SystemDelivery, HttpGetSysCarrierServiceAccount } from '@/service/costbilling';
import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
	mixins: [mixin],
	components: {
		compWrapper: () => import('@components/templates/wrapper'),
		compFormEdit: () => import('@components/templates/formedit'),
	},
	data() {
		return {
            id: this.$route.query.id,
            type: this.$route.params.type,
			loading: false,
			formData: {},
			systemServiceList: [],
		};
	},
	created(){
        // HttpGetSysCarrierServiceAccount()
        // // SystemDelivery()
        // .then(res=>{
        //     this.systemServiceList = res.data.map(res=>{
        //         return {
        //             value: res.carrierServiceCode,
        //             // label: `${res.carrierServiceCode}(${res.carrierServiceName})`
        //             label: res.carrierServiceCode
        //         }
        //     })
        // })
        if(this.type=='add') return
        this.getDetail()
    },
	computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCarrierAllList', 'getCarrierServiceAllList']),
		getBase() {
			return [
                {
                    label: this.$t('fbb.expresspackage.service_code', { defaultValue: "承运商" }),
                    tag: 'vSelect',
                    key: 'carrierCode',
                    options: [
                        {label:'FedEx',value:'FedEx'},
                        {label:'FedEx Freight',value:'FedEx Freight'},
                        {label:'UPS',value:'UPS'}
                    ],
                    props:{
                        filterable:true,
                    },
                },
                {
                    label: this.$t('fbb.carrieraccount.carrieraccount_service',{defaultValue:'承运商服务'}),
                    key: 'webCarrierServiceName',
                    tag: 'vInput',
                },
                {
                    label: '系统承运商服务',
                    key: 'carrierServiceCode',
                    tag: 'vSelect',
                    options:this.getCarrierServiceAllList.map(item=>{
                        return {
                            value: item.attach.carrierServiceCode,
                            label: item.label,
                        }
                    }),
                    props:{
                        filterable:true,
                    },
                },
                {
                    label:'国别',
                    tag: 'vSelect',
                    key: 'country',
                    options: [
                        {value: 'US', label: 'US'},
                        {value: 'CA', label: 'CA'},
                    ],
                },
                {
                    label:'状态',
                    key:'status',
                    tag:'vSelect',
                    options:[
                        {label:"启用",value:1},
                        {label:"停用",value:0},
                    ]
                }
			]
		},

	},
	methods: {
		getDetail() {
			this.loading = true
			HttpFuelExtraOne({
                id:this.id
			}).then(res => {
				this.loading = false
				this.formData = res.data
			}, err => {
				this.loading = false
				this.$VMessage.error(err.message);
			})
		},
		close() {
            this.$router.push({
                name: 'costbillingfuelextraList',
            });
		},
		async submit() {
			const valid = await this.$refs['accountform'].validate();
			if (!valid) return;
			this.loading = true
			HttpSaveFuelExtra(this.formData).then(res => {
                this.loading = false
				this.$VMessage.success(res.message);
				this.close();
				// this.$emit('on-update');
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		}
	}
};
</script>
